import Vue from 'vue';
import BrandsSearch from '../containers/BrandsSearch.vue';
export default Vue.extend({
    props: {
        menuCategories: {
            type: Array,
            default: () => [],
        },
        activeCategory: {
            type: String,
            default: '',
        },
    },
    components: {
        BrandsSearch,
    },
    data() {
        return {
            showGradient: true,
            activeDropdownId: null,
        };
    },
    mounted() {
        this.attachAlcoholModal();
        this.attachHorizontalScroll();
        document.addEventListener('mouseover', this.onGlobalMouseOver);
    },
    beforeDestroy() {
        document.removeEventListener('mouseover', this.onGlobalMouseOver);
        const menu = this.$el;
        if (menu && menu.__wheelListener) {
            menu.removeEventListener('wheel', menu.__wheelListener);
        }
    },
    methods: {
        openDropdown(id) {
            this.activeDropdownId = id;
        },
        closeAllDropdowns() {
            this.activeDropdownId = null;
        },
        onGlobalMouseOver(event) {
            const navMenu = this.$el;
            if (!navMenu)
                return;
            const isInsideNav = navMenu.contains(event.target);
            if (!isInsideNav) {
                this.closeAllDropdowns();
            }
        },
        attachAlcoholModal() {
            if (this.$root.$refs.AlcoholAlert) {
                this.$root.$refs.AlcoholAlert.attachClickToShowModal();
            }
        },
        attachHorizontalScroll() {
            const menu = this.$el;
            if (!menu)
                return;
            const onWheel = (e) => {
                if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                    e.preventDefault();
                    menu.scrollLeft += e.deltaY;
                }
            };
            menu.addEventListener('wheel', onWheel, { passive: false });
            menu.__wheelListener = onWheel;
        },
    },
});
